<template>
  <div class="score_container">
    <div v-if="showScore">
      <div class="presonal-title">
        <span>{{ $t('lang.external.personal.content.one.实验成绩') }}</span>
      </div>
      <div class="content">
        <el-table
          ref="singleTable"
          :data="tableData"
          highlight-current-row
          @current-change="handleCurrentChange"
          class="content_table"
          :header-cell-style="tableHeader"
          :cell-style="set_cell_style"
        >
          <el-table-column
            type="index"
            width="100"
            property="table_count"
            :label="$t('lang.external.personal.content.one.序号')"
          >
          </el-table-column>
          <el-table-column
            property="courseName"
            :label="$t('lang.external.personal.content.one.实验名称')"
            width="300"
          >
          </el-table-column>
          <el-table-column
            property="spendSecond"
            :label="$t('lang.external.personal.content.one.训练时长')"
          >
          </el-table-column>
          <el-table-column
            property="finishTime"
            :label="$t('lang.external.personal.content.one.完成时间')"
            width="170"
          >
          </el-table-column>
          <el-table-column
            property="expTotalScore"
            :label="$t('lang.external.personal.content.one.步骤得分')"
          >
          </el-table-column>
          <el-table-column
            property="reportScore"
            :label="$t('lang.external.personal.content.one.报告得分')"
          >
          </el-table-column>
          <el-table-column
            property="operation"
            :label="$t('lang.external.personal.content.one.操作')"
          >
            <template slot-scope="scope">
              <p @click="handleStep(scope.row)" custom-class="handleStep">
                {{ scope.row.operation }}
              </p>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <el-dialog
        :title="$t('lang.external.personal.content.one.查看步骤')"
        :visible.sync="dialogTableVisible"
        custom-class="delete-dialog"
        class="stepDialog"
      >
        <div class="experimentName">
          <span
            >{{ $t('lang.external.personal.content.one.虚拟实验：')
            }}{{ diaLogData.courseName }}</span
          >
        </div>
        <div class="center_data">
          <div class="scoreInfos_box">
            <div class="scoreInfos">
              <span
                >{{ $t('lang.external.personal.content.one.总分：')
                }}{{ diaLogData.totalScore }}</span
              >
            </div>
            <div class="scoreInfos">
              <span
                >{{ $t('lang.external.personal.content.one.耗时：')
                }}{{ diaLogData.spendSecond }}</span
              >
            </div>
            <div class="scoreInfos">
              <span
                >{{ $t('lang.external.personal.content.one.排名：')
                }}{{ diaLogData.ranking
                }}<button class="lookButton" @click="lookClick">
                  {{ $t('lang.external.personal.content.one.查看') }}
                </button></span
              >
            </div>
          </div>
        </div>
        <el-table
          class="el_table_dialog"
          :data="diaLogData.child"
          :header-cell-style="tableHeader_dialog"
          :cell-style="set_cell_style_dialog"
          border
        >
          <el-table-column
            property="courseSonName"
            :label="$t('lang.external.personal.content.one.实验名称')"
            width="150"
            hight="50"
            align="center"
          ></el-table-column>
          <el-table-column
            property="spendSecond"
            :label="$t('lang.external.personal.content.one.花费时间')"
            width="200"
            align="center"
          >
          </el-table-column>
          <el-table-column
            property="expTotalScore"
            :label="$t('lang.external.personal.content.one.分数')"
            align="center"
          ></el-table-column>
        </el-table>
      </el-dialog>
    </div>
    <rankingList v-else @change="isShow" />
  </div>
</template>
<script>
import rankingList from './RankingList/rankingList.vue'
import { experScore } from '@/api/personalCenter/index'
import { seconds_to_minutes } from '@/utils/timeFormat'
import { scoreDetail } from '@/api/personalCenter/index'
import { formatLan } from '@/utils/lanFormat'
export default {
  name: 'experimentalScore',
  components: {
    rankingList,
  },
  data() {
    return {
      diaLogData: {},
      showScore: true,
      dialogTableVisible: false,
      tableData: [],
    }
  },
  methods: {
    setCurrent(row) {
      this.$refs.singleTable.setCurrentRow(row)
    },
    handleCurrentChange(val) {
      this.currentRow = val
    },

    //实验成绩-表格
    tableHeader({ row, column, rowIndex, columnIndex }) {
      return 'text-align:center'
    },
    //实验成绩-表格
    set_cell_style({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 6) {
        return 'text-align:center;color:#A63528;cursor: pointer;'
      } else {
        return 'text-align:center'
      }
    },
    //弹窗
    tableHeader_dialog({ row, column, rowIndex, columnIndex }) {
      return 'background-color:#DCE9F3;color:#0C5893;height:10px'
    },
    //弹窗
    set_cell_style_dialog({ row, column, rowIndex, columnIndex }) {
      // if (columnIndex === 6) {
      //   return 'text-align:center;color:#A63528;cursor: pointer;'
      // } else {
      //   return 'text-align:center'
      // }
    },
    //查看
    lookClick() {
      this.showScore = false
      this.$store.commit('SET_CRUMBS', ' 查看步骤 > 排行榜 ')
    },

    //弹窗项
    handleStep(item) {
      this.$store.commit('personal/SET_CURSEID', item.course_id)
      this.loadDialogData(item.id)
      this.dialogTableVisible = true
    },
    isShow(e) {
      this.showScore = e
      this.dialogTableVisible = e
    },
    experScoreData() {
      experScore().then((res) => {
        const { data } = res.data
        let array = []
        for (let i = 0; i < data.length; i++) {
          data[i]['courseName'] = formatLan(data[i]['courseName'])
          array.push(data[i])
        }
        this.tableData = array
        data.forEach((item) => {
          item.spendSecond = seconds_to_minutes(item.spendSecond)
          item.operation = this.$t(
            'lang.external.personal.content.one.成绩详情'
          )
        })
      })
    },
    loadDialogData(id) {
      scoreDetail(id).then((res) => {
        const { data } = res
        console.log(res)
        this.diaLogData = data
        this.diaLogData.spendSecond = seconds_to_minutes(
          this.diaLogData.spendSecond
        )
      })
    },
  },
  created() {
    this.experScoreData()
  },
}
</script>
<style lang="scss" scoped>
.score_container {
  width: 100%;
  position: relative;
}
.content_table {
  width: 100%;
  text-align: center;
  // background-color: aqua;
}
.content_table thead td {
  color: #7a7a7a;
}
.handleStep {
  cursor: pointer;
}
::v-deep .delete-dialog {
  width: 500px;
  border-radius: 5px;
}

::v-deep .delete-dialog .el-dialog__header {
  height: 45px;
  line-height: 45px;
  position: relative;
  padding: 0 20px;
  background-color: #edf2f6;
  color: #666666;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
}
::v-deep .el-dialog__headerbtn .el-dialog__close {
  transform: translateY(-30%);
  color: #999999;
}
::v-deep .el-dialog__title {
  font-size: 16px;
  font-weight: bold;
  color: #666666;
}

.center_data {
  margin-top: 23px;
}
.scoreInfos_box {
  display: flex;
}
.scoreInfos {
  width: 100px;
  display: inline-block;
  height: 27px;
  flex: 1;
  vertical-align: top;
  line-height: 27px;
  // text-align: center;
}

.dis {
  display: inline-block;
  top: 0;
}
.lookButton {
  width: 54px;
  height: 26px;
  border: 1px #a63528 solid;
  border-radius: 5px;
  background-color: #feefed;
  color: #a63528;
  margin-left: 10px;
  cursor: pointer;
}
.el_table_dialog {
  margin-top: 26px;
  border-radius: 5px;
}
</style>